export default "/images/85a381d29ec75cdf8ed3797f0939b265.avif";